module.exports = [
  { id: 'google', name: 'Google' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'stumbleupon', name: 'StumbleUpon', hasAccount: true }
]
